import { combineReducers } from "redux";
import tableReducer from "../table/tableReducer";
import orderReducer from "../order/orderReducer";
import foodReducer from "../food/foodReducer";
import loadingReducer from "./loadingReducer";
import branchReducer from "../branches/branchReducer";
import rawItemReducer from "../rawItems/rawItemReducer";
import userLoginReducer from "../userLogin/userReducer";
import hotelReducer from "../hotel/hotelReducer";
import userProfileDataReducer from "../userProfileData/userProfileDataReducer";
import monthlyReportReducer from "../monthlyReport/monthlyReportReducer";
import invoiceReducer from "../Invoices/invoiceReducer";
import stockConsumptionReducer from "../stockconsumption/stockConsumptionReducer";
import expensesReducer from "../expenses/expensesReducer";
import supplierReducer from "../supplier/supplierReducer";
import waiterReducer from "../Waiters/waitersReducer";
import restaurantinfoReducer from "../restaurantinfo/restaurantinfoReducer";
import taxsettingReducer from "../TaxSetting/taxsettingReducer";
import PrinterReducer from "../Printer/PrinterReducer";
import ReportReducer from "../Report/reportReducer";
import categoryReducer from "../category/categoryReducer";
import dashboardReducer from "../dashboard/dashboardReducer";
import profitlossReducer from "../profitloss/profitlossReducer";
import notificationReducer from "../notificationSlice/notificationReducer";
import kitchenReducer from "../kitchen/kitchenReducer"; // ADD THIS IMPORT


const appReducer = combineReducers({
  monthlyReportReducer,
  tableReducer,
  orderReducer,
  foodReducer,
  branchReducer,
  loadingReducer,
  rawItemReducer,
  userLoginReducer,
  userProfileDataReducer,
  hotelReducer,
  invoiceReducer,
  stockConsumptionReducer,
  expensesReducer,
  supplierReducer,
  waiterReducer,
  restaurantinfoReducer,
  taxsettingReducer,
  PrinterReducer,
  ReportReducer,
  categoryReducer,
  dashboardReducer,
  profitlossReducer,
  notification: notificationReducer,
  kitchen: kitchenReducer
});

const rootReducer = (state, action) => {
  if (action.type === "LOGOUT") {
    const { notifications } = state || {};
    state = { notifications };
  }

  return appReducer(state, action);
};
export default rootReducer;
